export const cookieBannerName = 'gatsby-gdpr-google-tagmanager'
